import { render } from "./linked-organisations.vue?vue&type=template&id=7a66bf7b&ts=true"
import script from "./linked-organisations.ts?vue&type=script&lang=ts&external"
export * from "./linked-organisations.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__